export default __webpack_public_path__ + "static/media/rnamepic.fea49ff7.jpg";